<span class="wk-cm__south-panel__t1-title">{{ "CardModal.ApplyToAll" | translate }}</span>
<checkbox-field-pds3 labelFor="return_status" [label]="'CardModal.TaxprepStatus' | translate">
    <input
        id="return_status"
        name="return_status"
        value="return_status"
        type="checkbox"
        [checked]="cardModalService.returnStatusDefaultValue()"
        (change)="onReturnStatusCheckboxChange($event)"
        flow-id="checkbox"
    />
</checkbox-field-pds3>
<checkbox-field-pds3 labelFor="assigned_status" [label]="'CardModal.AssignedToSection' | translate">
    <input
        id="assigned_status"
        name="assigned_status"
        value="assigned_status"
        type="checkbox"
        [checked]="cardModalService.assignedStatusDefaultValue()"
        (change)="onAssignedStatusCheckboxChange($event)"
        flow-id="checkbox"
    />
</checkbox-field-pds3>
